import { GetVisitByIdStatusEnum } from 'woofwoof-api';

// Follows the status, not startTime: a late CREATED visit still "will take
// place", but one already in progress must not — even from an earlier day.
export const upcomingVisitHeadingKey = (
  status?: GetVisitByIdStatusEnum,
): string =>
  status === GetVisitByIdStatusEnum.Pending
    ? 'visit.pendingCardNearest'
    : 'visit.upcomingCardNearest';
